// src/pages/Auditorias/Configuracoes/variaveis.js

/**
 * Verificação das %VARIAVEIS% de um prompt contra as que o motor fornece.
 *
 * O motor substitui por texto simples (`_render` em auditoria_service.py: um
 * `replace` por chave conhecida). Consequência prática: uma variável que ele
 * não conheça **não dá erro** — fica no prompt em cru e chega assim ao modelo.
 * E uma variável que se apague do texto também não dá erro — o modelo passa
 * simplesmente a trabalhar sem esse conteúdo. Nenhum dos dois casos aparece no
 * ecrã da auditoria; só na qualidade do resultado, meia hora depois.
 *
 * Daí os dois avisos. O mesmo formato do promptService.js: %NOME_DA_VARIAVEL%.
 */
const PADRAO = /%([A-Z_0-9]+)%/g;

/** Nomes de variáveis usados no texto, sem repetições e pela ordem de aparição. */
export function variaveisUsadas(texto) {
  const encontradas = [...(texto || '').matchAll(PADRAO)].map((m) => m[1]);
  return [...new Set(encontradas)];
}

/**
 * Compara o par SYSTEM/USER com as variáveis disponíveis para a origem.
 * Devolve { desconhecidas, porUsar } — ambos arrays de nomes.
 */
export function verificarVariaveis(textoSystem, textoUser, disponiveis = []) {
  const usadas = [...new Set([
    ...variaveisUsadas(textoSystem),
    ...variaveisUsadas(textoUser),
  ])];

  return {
    // Estão no texto mas o motor não as substitui — vão em cru para o modelo
    desconhecidas: usadas.filter((v) => !disponiveis.includes(v)),
    // O motor fornece-as mas o texto não as usa — esse conteúdo não é enviado
    porUsar: disponiveis.filter((v) => !usadas.includes(v)),
  };
}
